import React from 'react';
import { ForgotPasswordForm } from '../../../components/organism/ForgotPasswordForm/ForgotPasswordForm';
import { Link } from 'react-router-dom';

export const ForgotPasswordPage: React.FC = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                <div>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Recuperar Contraseña
                    </h2>
                    <p className="mt-2 text-center text-sm text-gray-600">
                        Ingresa tu correo electrónico para recibir un enlace de recuperación.
                    </p>
                </div>
                <ForgotPasswordForm />
                <div className="text-center">
                    <Link to="/login" className="font-medium text-primary hover:text-primary-dark">
                        Volver al inicio de sesión
                    </Link>
                </div>
            </div>
        </div>
    );
};
